import VerticalDragSwitch from './VerticalDragSwitch';

export default VerticalDragSwitch;
